import { send } from "./auth";

/* 프로젝트(`crates/api/src/projects.rs`). 읽기는 로그인한 누구나, 쓰기는 `/admin/` 아래다.
   `taskCount` 등은 서버가 센 값 그대로 — 화면이 다시 세지 않는다. */

export type Project = {
  id: string;
  name: string;
  description: string | null;
  createdAt: string;
  repositoryIds: string[];
  taskCount: number;
  openTaskCount: number;
  milestoneCount: number;
  /** 묶인 조직 — `null` 은 조직 없음(누구나 봄, docs/decisions/org.md). */
  orgId: string | null;
};

const enc = encodeURIComponent;

/** `GET /repos` 에서 프로젝트 화면이 쓰는 칸만 — 이름표(`owner/name`)를 붙이는 데 쓴다. */
export type RepoName = { id: string; owner: string; name: string };

export const projectApi = {
  repos: () => send<RepoName[]>("GET", "/repos"),
  list: () => send<Project[]>("GET", "/projects"),
  /** `id` 를 비우면 서버가 만든다. */
  create: (b: { id?: string; name: string; repositoryIds?: string[] }) => send<Project>("POST", "/admin/projects", b),
  rename: (id: string, name: string) => send<Project>("PATCH", `/admin/projects/${enc(id)}`, { name }),
  /** 묶음을 **통째로** 바꾼다(PUT) — 하나만 더하는 문은 없다. */
  setRepos: (id: string, repositoryIds: string[]) =>
    send<Project>("PUT", `/admin/projects/${enc(id)}/repositories`, { repositoryIds }),
  /** 이슈 · 마일스톤이 걸렸으면 409 + 서버 문장(`message`)이다. */
  remove: (id: string) => send<null>("DELETE", `/admin/projects/${enc(id)}`),
};
